import React, { useEffect } from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import List_It_Logo from "../assets/image/ListIt.png";
import './Styles/Login.css'
import { ColorTheme } from "../../constant/ColorTheme";
import { NavigationRoutes } from "../../constant/Routes";
import { isAuthenticated } from "../../helpers/AdminAuthentication";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import LoaderButton from "../common/LoaderButton";
import { newPasswordRequest } from "../../redux/actionDispatcher/auth/newPassDispatcher";


function CreateNewPassword({ newPassword, newPasswordRequest }) {
    const { token } = useParams(); // Get "1-887167" from URL

    const [userId, resetToken] = token.split("-");
    const validationSchema = Yup.object({
        newPassword: Yup.string()
            // .min(6, "Password must be at least 6 characters")
            .required("Please Enter Password"),

        confirmNewPassword: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
            .required("Please Confirm Password"),
    });
    var navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            newPassword: "",
            confirmNewPassword: "",
        },
        validationSchema,


        onSubmit: (values) => {
            
            // // console.log(values);
            const data = {
                token:resetToken,
                user_id:userId,
                new_password: formik.values.newPassword,
                confirm_new_password: formik.values.confirmNewPassword,
            };
            console.log(data);

            //passing the data in fetchUsers which contain the dispatch method
            //Add new lines and response in fetchUsers function
            newPasswordRequest(data, navigate);
        },
    });
    useEffect(() => {
        if (isAuthenticated()) {
            navigate(NavigationRoutes.ADMIN_DASHBOARD);
        }
    }, [navigate]);

    return (<>
        <div
            className="position-absolute top-50 start-50 translate-middle login-card "
        >

            <form onSubmit={formik.handleSubmit} className="login-form">
                <div className="d-flex justify-content-center mb-3">
                    <img
                        src={List_It_Logo}
                        alt="logo list"
                        height={80}
                        style={{ alignItems: "center", }}
                    />{" "}
                    <br />
                </div>
                <div className="">
                    <h4 className="h4 fw-bold" style={{ color: ColorTheme.colors.primary }}> <b> New Password </b></h4>
                    <p className="p mb-3 " style={{ color: "black" }}>  Please enter your new password for login.  </p>
                </div>
                <div className="mb-3 input-login-box">
                    <input

                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="newPassword"
                        type="password"
                        className="form-control login-input mt-3"
                        placeholder="New Password"
                        disabled={newPassword.loading}
                    />
                    {formik.errors.newPassword && formik.touched.newPassword ? (
                        <div className="text-danger fs-6">{formik.errors.newPassword}</div>
                    ) : (
                        ""
                    )}
                    <input

                        value={formik.values.confirmNewPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="confirmNewPassword"
                        type="password"
                        className="form-control login-input mt-3"
                        placeholder="Confirm New Password"
                        disabled={newPassword.loading}
                    />
                    {formik.errors.confirmNewPassword && formik.touched.confirmNewPassword ? (
                        <div className="text-danger fs-6">{formik.errors.confirmNewPassword}</div>
                    ) : (
                        ""
                    )}

                </div>


                <button
                    className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                    type="submit"
                // disabled={newPassword.loading}
                >
                    {/* used loader for button here ============= */}
                    {
                        newPassword.loading ? (<LoaderButton />) :

                            "Submit"}
                </button>

            </form>
        </div>
    </>
    );
}

const mapStateToProps = (state) => {
    return {
        newPassword: state.newPassword,
    };
};

//passing the newPassword in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
    return {
        newPasswordRequest: (data, navigate) => dispatch(newPasswordRequest(data, navigate)),
    };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(CreateNewPassword);

